var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m3.345.517a.622.622 0 0 0 -.374.025c-1.348.524-2.197 2.446-2.396 3.768-.624 4.29 2.77 8.013 5.891 10.46 2.77 2.172 8.087 5.742 11.233 2.3a2.592 2.592 0 0 0 .849-1.673c-.076-1.048-1.049-1.8-1.8-2.371-.574-.425-1.772-1.6-2.521-1.573-.673.025-1.1.723-1.522 1.148l-.749.749c-.125.124-1.722-.924-1.9-1.049a12.608 12.608 0 0 1 -1.822-1.423 11.782 11.782 0 0 1 -1.473-1.7 8.716 8.716 0 0 1 -1.044-1.822s.874-.948 1.124-1.323c.524-.8.923-1.423.325-2.371a5.638 5.638 0 0 0 -.8-.924 15.357 15.357 0 0 0 -1.647-1.448 3.518 3.518 0 0 0 -1.374-.773z","fill":"none","stroke":"#54d2df","transform":"translate(.004 .002)"}));
}

Phone.defaultProps = {"height":"19.033","viewBox":"0 0 19.052 19.033","width":"19.052"};

module.exports = Phone;

Phone.default = Phone;
